import * as React from "react";
import { Row, Col } from "antd";
import { HeaderTitle, OrderRow, TableCol, OrderTotalCol, BolNumberLayout, KWLReferenceLayout, VesselLayout, StoragetoDateLayout, ChargesLayout, OrderTotalLayout, HeaderCol, TableValueCol, OrderTotalHeaderCol, OrderTotalHeaderLayout } from "./OrderDetail.Styled";
import { IBolData, IBolCharge } from "Core/Api/Payment/Api";
import Utility from "Core/Utility";
import moment from "moment";

export interface Props {
    children?: React.ReactNode,
    receiptDetails?: IBolData[]
}

export interface State {
    charge: IBolCharge[],
    totalChargeAmount?
}

export default class OrderDetail extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props)
        this.getCharges = this.getCharges.bind(this);

        this.state = {
            charge: [{}],
            totalChargeAmount: 0,
        }
    }

    componentDidMount() {
        this.getCharges();
        this.getTotalChargeAmount();
    }

    getCharges() {
        if (this.props.receiptDetails) {
            this.props.receiptDetails.map(charges => {
                if (charges.charges) {
                    this.setState({ charge: charges.charges })
                }
            }
            )
        }
    }

    getTotalChargeAmount() {
        let sum = 0;
        if (this.props.receiptDetails) {
            this.props.receiptDetails?.map(details =>
                details.charges?.map(amountFound => {
                    if (amountFound.chargeAmount) {
                        sum += amountFound.chargeAmount
                    }
                    this.setState({ totalChargeAmount: sum })
                }

                )
            )
        }

    }

    render() {
        const { receiptDetails } = this.props;
        return (
            //note that the orderline was done this way so that it could stay in the same col as its 
            //header because of aesthetic purposes during mobile view.
            <>
                <HeaderTitle>Order Details:</HeaderTitle>
                {/*A list of bill of ladings selected to be paid for: */}
                <OrderRow>
                    <Col span={24}>
                        <Row>
                            <Col span={24}>
                                <TableCol {...BolNumberLayout}>
                                    <Row>
                                        <strong><HeaderCol span={24}>Bill of Lading Number</HeaderCol></strong>
                                    </Row>
                                    {receiptDetails?.map(details =>
                                        <Row>
                                            {
                                                <Col span={24}>{details ? details.bolNumber : "N/A"}</Col>
                                            }
                                        </Row>
                                    )}
                                </TableCol>

                                <TableCol {...KWLReferenceLayout}>
                                    <Row>
                                        <strong><HeaderCol span={24}>KWL Reference</HeaderCol></strong>
                                    </Row>
                                    {receiptDetails?.map(details =>
                                        <Row>
                                            {
                                                <Col span={24}>{details ? details.bolReference : "N/A"}</Col>
                                            }
                                        </Row>
                                    )}
                                </TableCol>

                                <TableCol {...VesselLayout}>
                                    <Row>
                                        <strong><HeaderCol span={24}>Vessel Arrival Date</HeaderCol></strong>
                                    </Row>
                                    {receiptDetails?.map(details =>
                                        <Row>
                                            {
                                                <Col span={24}>{details.arrivalDate ? Utility.ToDateString(moment.parseZone(details.arrivalDate)) : "N/A"}</Col>
                                            }
                                        </Row>
                                    )}
                                </TableCol>

                                <TableCol {...StoragetoDateLayout}>
                                    <Row>
                                        <strong><HeaderCol span={24}>Storage-To-Date</HeaderCol></strong>
                                    </Row>
                                    {/* NOT SURE ABOUT THIS VALUE AS CAN BE SEEN FROM THE HEADER VS. VALUE */}
                                    {receiptDetails?.map(details =>
                                        <Row>
                                            {
                                                <Col span={24}>{details ? Utility.ToDateString(Utility.ConvertToStandardTimezone(moment.parseZone(details.storageDueDate))) : "N/A"}</Col>
                                            }
                                        </Row>
                                    )}
                                </TableCol>

                                <TableCol {...ChargesLayout}>
                                    <Row>
                                        <strong><HeaderCol span={24}>Charges</HeaderCol></strong>
                                    </Row>
                                    {receiptDetails?.map(details =>
                                        <Row>
                                            {details ?
                                                <>
                                                    {details.charges?.map(charge =>
                                                        <Col span={24}>${charge.chargeAmount}</Col>
                                                    )}
                                                </> :
                                                <Col span={24}>N/A</Col>
                                            }
                                        </Row>
                                    )}
                                </TableCol>
                            </Col>
                        </Row>

                        <Row >
                            <OrderTotalHeaderCol {...OrderTotalHeaderLayout}>
                                <strong>Order Total</strong>
                            </OrderTotalHeaderCol>
                            <OrderTotalCol {...OrderTotalLayout}>
                                {/* this might be overkill */}
                                <>{this.state.charge?.[0]?.chargeCurrency} ${this.state.totalChargeAmount}</>

                            </OrderTotalCol>
                        </Row>
                    </Col>
                </OrderRow>
            </>
        )
    }
}
